<!-- assets/components/Admin/SettingsView.vue -->

<template>
    <Paper class="account">
        <div class="hidden md:flex border-b border-gray-200 pt-2.5 px-0 pb-1">
            <div class="main-header-left">
                <h3 class="tracking-normal text-cal-4A4A4A my-2.5 mx-0 font-bold text-xl">Settings</h3>
            </div>
        </div>

        <column-view>
            <div class="column">
                <div class="column-row">
                    <div class="column-row-title">Weekly New Projects Email</div>
                    <div class="column-row-value">Receive weekly emails of new projects added to Construct-A-Lead</div>
                    <label class="column-row-check control checkbox">
                        <input type="checkbox" v-model="user.alert_weekly" />
                        <span class="control-indicator"></span>
                    </label>
                </div>
                <div class="column-row">
                    <div class="column-row-title">Value</div>
                    <div class="column-row-value">Select the project value you want to show up in your search results.</div>
                    <vue-form>
                        <div slot="elements">
                            <div class="form-half-field">
                                <label>
                                    <span>Operator</span>
                                    <segmented-control
                                        :options="['Less Than', 'Greater Than']"
                                        :use-index="true"
                                        v-model="operator"></segmented-control>
                                    <span>Millions</span>
                                    <input type="text" v-model="value" />
                                </label>
                            </div>
                        </div>
                    </vue-form>
                </div>
                <div class="account-save">
                    <vue-button
                        @click="save()"
                        type="green large"
                        icon="nav-save">Save Changes</vue-button>
                </div>
            </div>
        </column-view>
    </Paper>
</template>

<script>

import Paper from '../Layout/Paper.vue'
import ColumnView from '../Shared/ColumnView.vue';
import VueButton from '../Shared/VueButton.vue';
import VueModal from '../Shared/VueModal.vue';
import VueForm from '../Shared/VueForm.vue';
import SegmentedControl from '../Shared/SegmentedControl.vue';

import WebServices from '../../services/WebServices';

export default {

    components: { Paper, VueButton, VueModal, VueForm, ColumnView, SegmentedControl },

    data () {
        return {
            userServices: WebServices("Users"),
            projectServices: WebServices("Projects"),
            user: { },
            showModal: false,
            options: {
                states: [],
                projectTypes: []
            },
            projectTypes: [],
            states: [],
            operator: null,
            value: null
        }
    },

    created () {

        this.get();
        this.getOptions();
    },

    computed: {

    },

    methods: {

        get () {

            this.userServices
                .get({ withSettings: true }, 'Me')
                .then(function(response) {
                    this.user = response.data.data
                    this.projectTypes = this.user.alert_project_types.map(function(item) { return item.id });
                    this.states = this.user.alert_states.map(function(item) { return item.id });
                    this.operator = this.user.alert_operator;
                    this.value = this.user.alert_value;
                }.bind(this));
        },

        getOptions () {

            this.projectServices
                .get({}, 'AdvancedOptions')
                .then(function(response) {

                    var data = response.data.data;
                    this.options.states = data.states;
                    this.options.projectTypes = data.projectTypes;
                }.bind(this));
        },

        save () {

            this.user.alert_project_types = this.projectTypes;
            this.user.alert_states = this.states;
            this.user.alert_operator = this.operator;
            this.user.alert_value = this.value;

            this.userServices
                .update(this.user)
                .then((response) => {

                    this.get();
                    swal({
                        title: "Success!",
                        text: "Your settings were saved successfully.",
                        type: "success",
                        confirmButtonColor: "#40B572",
                        timer: 2500
                    }, function() {
                        swal.close();
                    }.bind(this));

                }, (response) => {

                    console.log("error");
                });
        },

        hasProjectType (projectType) {

            var index = this.projectTypes.indexOf(projectType.id);
            if (index > -1) {
                return true;
            }
            return false;
        },

        toggleProjectType (projectType) {

            var index = this.projectTypes.indexOf(projectType.id);
            if (index > -1) {
                this.projectTypes.splice(index, 1);
            }
            else {
                this.projectTypes.push(projectType.id);
            }
        },

        hasState (state) {

            var index = this.states.indexOf(state.id);
            if (index > -1) {
                return true;
            }
            return false;
        },

        toggleState (state) {

            var index = this.states.indexOf(state.id);
            if (index > -1) {
                this.states.splice(index, 1);
            }
            else {
                this.states.push(state.id);
            }
        },
    }
}

</script>

<style>
.account .column-row {
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 14px;
    padding: 20px;
    border-bottom: 1px solid #DDD;
    position: relative;
}

.account .column-row:first-child {
    margin-top: -20px;
}

.account .column-row-title {
    font-weight: 500;
    font-size: 14px;
    color: #4A4A4A;
}

.account .column-row-value {
    color: #969696;
    border-bottom: 0px;
}

.account .column-row-check {
    position: absolute;
    right: 40px;
    top: 50%;
    margin-top: -15px;
    width: auto;
    padding: 0px;
}

.alert-project-type-list span,
.alert-project-type-list label {
    display: inline-block;
    flex-grow: 1;
    width: 33%;
    line-height: 24px;
}

.account-save {
    float: right;
    padding: 10px 0px;
}
</style>

